// extracted by mini-css-extract-plugin
export default {"resetModal":"ResetConfirmationModal_resetModal__0oGoP","buttons":"ResetConfirmationModal_buttons__bO1Zs"};